import React, {useEffect} from 'react'
import {createRoot} from 'react-dom/client'

// Axios
import axios from 'axios'
import {Chart, registerables} from 'chart.js'
import {QueryClient, QueryClientProvider} from 'react-query'
import {ReactQueryDevtools} from 'react-query/devtools'
// Apps
import {MetronicI18nProvider} from './_metronic/i18n/Metronici18n'
import './_metronic/assets/sass/style.scss'
import './_metronic/assets/sass/plugins.scss'
import './_metronic/assets/sass/style.react.scss'
import {AppRoutes} from './app/routing/AppRoutes'
import ReduxAuthProvider from './app/modules/auth/ReduxAuthProvider'
import {setupAxiosWithRedux} from './app/modules/auth/ReduxAuthHelpers'
import {ToastContainer} from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import './App.css'
import {TimeTrackProvider} from './app/modules/user/context/TimeTrackedContext'
import {HealthAlertNotificationProvider} from './app/modules/user/context/NotificationContext'
import { BillingDropdownProvider } from './app/modules/user/context/BillingDropdownContext'
import { MADoctorDropdownProvider } from './app/modules/user/context/MADoctorDropdownContext'

// const version = packageJson.version

setupAxiosWithRedux(axios)
Chart.register(...registerables)

const queryClient = new QueryClient()

const InnerApp = () => {
  // Remove local storage keys when the component mounts
  useEffect(() => {
    localStorage.removeItem('theme')
    localStorage.removeItem('kt_theme_mode_menu')
    localStorage.removeItem('kt_theme_mode_value')
  }, [])

  return (
    <QueryClientProvider client={queryClient}>
      <MetronicI18nProvider>
        <ReduxAuthProvider>
          <HealthAlertNotificationProvider>
            <TimeTrackProvider>
              <BillingDropdownProvider>
                <MADoctorDropdownProvider>
                  <AppRoutes />
                  <ToastContainer
                    position='top-right'
                    autoClose={2500}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme='light'
                    limit={3}
                  />
                </MADoctorDropdownProvider>
              </BillingDropdownProvider>
            </TimeTrackProvider>
          </HealthAlertNotificationProvider>
        </ReduxAuthProvider>
      </MetronicI18nProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  )
}

const App = () => {
  // Disable console.log in production
  if (process.env.REACT_APP_ENV === 'production') console.log = () => {}

  // const appEnv = process.env.REACT_APP_ENV || process.env.NODE_ENV // fallback if REACT_APP_ENV isn't set

  // // Disable cache busting in local development to prevent refresh loops
  // const isCacheBustingEnabled = false // Disabled to prevent unexpected reloads
  // const showVerbose = appEnv === 'development'

  // Disable cache buster completely to fix refresh loop
  return <InnerApp />

  // return (
  //   <CacheBuster
  //     currentVersion={version}
  //     isEnabled={isCacheBustingEnabled}
  //     isVerboseMode={showVerbose}
  //     loadingComponent={<Loader />}
  //     metaFileDirectory='.'
  //   >
  //     <InnerApp />
  //   </CacheBuster>
  // )
}

const container = document.getElementById('root')
if (container) {
  createRoot(container).render(<App />)
}
